import localforage from 'localforage';

export interface ChecklistState {
  selectedDocuments: Set<string>;
  selectedOptions: Map<string, string>;
  timestamp: number;
}

class ChecklistService {
  private storageKey = 'checklist_';

  async saveChecklist(formId: string, state: ChecklistState): Promise<void> {
    const serialized = {
      selectedDocuments: Array.from(state.selectedDocuments),
      selectedOptions: Object.fromEntries(state.selectedOptions),
      timestamp: state.timestamp,
    };
    await localforage.setItem(`${this.storageKey}${formId}`, serialized);
  }

  async loadChecklist(formId: string): Promise<ChecklistState | null> {
    const data = await localforage.getItem<any>(`${this.storageKey}${formId}`);
    if (!data) return null;

    return {
      selectedDocuments: new Set(data.selectedDocuments),
      selectedOptions: new Map(Object.entries(data.selectedOptions)),
      timestamp: data.timestamp,
    };
  }

  async clearChecklist(formId: string): Promise<void> {
    await localforage.removeItem(`${this.storageKey}${formId}`);
  }
}

export const checklistService = new ChecklistService();